import { gql } from "@apollo/client";

const schema = {
  list: {
    name: "unit",
    serviceName: "graphql",
    query: gql`
      query unit(
        $ids: [String]
        $manager_id: String
        $title: String
        $page: Int
        $limit: Int
        $orderBy_field: String # created_at
        $orderBy_direction: String # >DESC , ACS
        $is_active: Int # 0 , 1
        $for_admin: Int # >0 , 1
        $city_id: String
        $state_id: String
      ) {
        unit(
          ids: $ids
          manager_id: $manager_id
          title: $title
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
          is_active: $is_active
          for_admin: $for_admin
          city_id: $city_id
          state_id: $state_id
        ) {
          data {
            id
            type
            title
            manager {
              firstname
              lastname
            }
            media {
              id
              full_url
            }
          }
          total
        }
      }
    `,
  },
  delete: {
    name: "deleteUnit",
    serviceName: "admin",
    query: gql`
      mutation deleteUnit($ids: [String]!) {
        deleteUnit(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  assignment: {
    name: "unit",
    serviceName: "grapghql",
    query: gql`
      query unit($ids: [String]) {
        unit(ids: $ids) {
          data {
            id
            title
            media {
              full_url
            }
          }
        }
      }
    `,
  },
};

export default schema;
